/*
  Force a real download for links that point at a file.

  Shopify serves uploaded files from cdn.shopify.com while the storefront
  runs on the shop's own domain, and every browser silently ignores the
  `download` attribute on a cross-origin link - so a PDF opens in the
  built-in viewer instead of landing in the Downloads folder.

  Any link marked with data-force-download is fetched here and handed to
  the browser as a blob, which it always saves. Shopify also serves the
  same file from the shop's own domain under /cdn/shop/files/, so that
  same-origin URL is tried first and no CORS grant is needed.

  Markup:
    <a href="<file url>" download="<name>" data-force-download
       data-filename="<name>">Download</a>
*/
(function () {
  "use strict";

  var SELECTOR = "[data-force-download]";

  if (!window.fetch || !window.URL || !window.URL.createObjectURL) return;

  /* Candidate URLs to read the file from, best first. */
  function candidateUrls(href) {
    var urls = [];

    try {
      var parsed = new URL(href, window.location.href);
      var marker = parsed.pathname.lastIndexOf("/files/");

      if (parsed.origin !== window.location.origin && marker !== -1) {
        urls.push(
          window.location.origin +
            "/cdn/shop/files/" +
            parsed.pathname.slice(marker + "/files/".length) +
            parsed.search
        );
      }

      urls.push(parsed.href);
    } catch (error) {
      urls.push(href);
    }

    return urls;
  }

  function firstReadable(urls, index) {
    if (index >= urls.length) return Promise.reject(new Error("no source"));

    return fetch(urls[index], { credentials: "omit" })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.blob();
      })
      .catch(function () {
        return firstReadable(urls, index + 1);
      });
  }

  function fileNameFrom(link) {
    var named = link.getAttribute("data-filename") || link.getAttribute("download");
    if (named) return named;

    try {
      var path = new URL(link.href, window.location.href).pathname;
      return decodeURIComponent(path.split("/").pop()) || "download";
    } catch (error) {
      return "download";
    }
  }

  function saveBlob(blob, filename) {
    var objectUrl = URL.createObjectURL(blob);
    var link = document.createElement("a");

    link.href = objectUrl;
    link.download = filename || "";
    link.rel = "noopener";
    link.style.display = "none";

    /* Safari only honours the click when the link is in the document, and
       needs the object URL to outlive it for a moment. */
    document.body.appendChild(link);
    link.click();

    setTimeout(function () {
      if (link.parentNode) link.parentNode.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    }, 250);
  }

  /* Delegated, so links rendered later - theme editor re-renders, filtered
     lists - are covered without re-binding. */
  document.addEventListener(
    "click",
    function (event) {
      /* Leave modified clicks (open in new tab, save link as) alone. */
      if (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.defaultPrevented
      ) {
        return;
      }

      var link = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!link || !link.href) return;

      event.preventDefault();

      var filename = fileNameFrom(link);

      link.setAttribute("aria-busy", "true");

      firstReadable(candidateUrls(link.href), 0)
        .then(function (blob) {
          saveBlob(blob, filename);
        })
        .catch(function () {
          /* Nothing readable: fall back to the plain link. */
          window.location.href = link.href;
        })
        .then(function () {
          link.removeAttribute("aria-busy");
        });
    },
    false
  );
})();
